<template>
  <div
    id="app"
    class="content background-home"
    :style="sidebarStyle"
    :data-image="backgroundImage"
  >
    <div class="height-home">
      <div class="m-0 mt-2 height-home">
        <div class="row height-home">
          <div class="col-md-12  col-lg-12 col-sm-12 ">
            <solucoes-form
              v-show="isModalVisible"
              :tipoSolucao="tipoSolucao"
              @close="closeModal"
            ></solucoes-form>
            <card
              class="card-user mt-2 background-card align-center card-style"
            >
              <div class="row">
                <div class="col-md-12 max" style="text-align: center">
                  <h1 class="card-title" style="color: white ">
                    <b>Soluções</b>
                  </h1>
                  <p
                    class="mt-4"
                    style="color: white;  font-size: min(30px, 3vw); "
                  >
                    <b>
                      Temos soluções para residência, comércio e indústria.
                      Clique no seu caso e nossa base mais próxima entrará em
                      contato.
                    </b>
                  </p>
                  <div class="row">
                    <div class="col-md-4" @click="openModal(1)">
                      <div class="background-inner-card">
                        <h3 class="solution-title"><b>INDÚSTRIA</b></h3>
                        <img
                          class="solution-icon"
                          src="../../public/img/industria.png"
                          alt="Industrial"
                        />
                      </div>
                    </div>
                    <div class="col-md-4" @click="openModal(2)">
                      <div class="background-inner-card">
                        <h3 class="solution-title"><b>COMÉRCIO</b></h3>
                        <img
                          class="solution-icon"
                          style="width:58%;"
                          src="../../public/img/comercio.png"
                          alt="Comercial"
                        />
                      </div>
                    </div>
                    <div class="col-md-4" @click="openModal(3)">
                      <div class="background-inner-card">
                        <h3 class="solution-title"><b>RESIDÊNCIA</b></h3>
                        <img
                          class="solution-icon"
                          src="../../public/img/casa.png"
                          alt="Residencial"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import AnunciosServices from 'src/services/anuncios';
import Card from 'src/components/Cards/Card.vue';
import SolucoesForm from './Forms/SolucoesForm';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Card,
    SolucoesForm
  },
  data() {
    return {
      backgroundImage: '/img/home.jpg',
      anuncios: [],
      isModalVisible: false,
      tipoSolucao: 0
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      AnunciosServices.listarTodos()
        .then(response => {
          this.anuncios = _.get(response, 'data.result');
          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno ao carregar os anúncios. Tente novamente mais tarde.';

          this.$notifications.notify({
            message,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
            icon: 'fa fa-exclamation-triangle'
          });
        });
    },
    closeModal() {
      this.isModalVisible = false;
    },
    openModal(tipoSolucao) {
      this.tipoSolucao = tipoSolucao;
      this.isModalVisible = true;
    }
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
        backgroundSize:
          'cover' /* Resize the background image to cover the entire container */
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  max-width: 120%;
}
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center 10;
}

.height-home {
  height: 100%;
}

.card-style {
  height: 69%;
}

.background-card {
  background-color: rgba(36, 68, 109, 0.589);
}

.background-inner-card {
  background-color: rgba(191, 200, 212, 0.37);
  border-radius: 30px;
  cursor: pointer;
  height: 110%;
}

.background-home {
  height: -webkit-fill-available;
}

.join-logo {
  align-self: center;
}

.height-join {
  height: 70%;
}

.whatsapp-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
  box-sizing: border-box;
  height: 60px;
  width: 60px;
  cursor: pointer;
  box-shadow: 0 0 5px #444;
  transition-duration: 0.1s;
}

.carousel-position {
  position: absolute;
  bottom: 10px;
}

title-style {
  color: white !important;
}

.whatsapp-button:hover {
  box-shadow: 0 0 10px #444;
}

.whatsapp-logo {
  position: absolute;
  width: 60px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.min p {
  font-size: 10vw;
}

.solution-icon {
  width: 40%;
}

.solution-title {
  color: white;
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
